import { render, staticRenderFns } from "./downloadPanel.vue?vue&type=template&id=2f1d1bd7&scoped=true&lang=pug&"
import script from "./downloadPanel.vue?vue&type=script&lang=js&"
export * from "./downloadPanel.vue?vue&type=script&lang=js&"
import style0 from "./downloadPanel.vue?vue&type=style&index=0&id=2f1d1bd7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d1bd7",
  null
  
)

export default component.exports